import { render, staticRenderFns } from "./AreaRegionSetup.vue?vue&type=template&id=09c11b9d&scoped=true"
import script from "./AreaRegionSetup.vue?vue&type=script&lang=ts"
export * from "./AreaRegionSetup.vue?vue&type=script&lang=ts"
import style0 from "./AreaRegionSetup.vue?vue&type=style&index=0&id=09c11b9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c11b9d",
  null
  
)

export default component.exports